/* eslint-disable sort-keys  */

// Logika Uhladania textov nazovStranky.typElementu.nazov

const translations: Record<string, string | ((...args: string[]) => string)> = {
	email: 'E-mail',
	password: 'Heslo',
	confirmPassword: 'Potvrdenie hesla',
	newPassword: 'Nové heslo',
	save: 'Uložiť',
	phoneNumber: 'Telefóne číslo',
	firstName: 'Meno',
	lastName: 'Priezvisko',
	street: 'Ulica',
	city: 'Mesto',
	zip: 'PSČ',
	country: 'Kraina',
	companyName: 'Názov firmy',
	ico: 'IČO',
	dic: 'DIČ',

	cookie_consent:
		'Naša stránka používa cookies, aby sme vám mohli ponúknuť pohodlný nákupný zážitok, správne zobrazovanie produktov a prehľad o tom, čo vás na našej ponuke najviac zaujíma. Pokračovaním potvrdzujete svoj súhlas s ich použitím.',

	'navigation.aboutUs': 'O nás',
	'navigation.contacts': 'Kontaky',
	'navigation.products': 'Výrobky',
	'navigation.store': 'Predajňa',
	'navigation.distribution': 'Distribúcia',

	// Distribution Page
	'distribution.heading.distribution': 'Distribúcia mäsa a mäsových výrobkov',
	'distribution.heading.mobileShop': 'Pojazdné Predajne',

	'distribution.paragraph.distribution.title': 'Nemusíte nikde chodiť  - my prídeme k vám !',
	'distribution.paragraph.distribution.detail':
		'Disponujeme vlastnou distribúciou, vďaka ktorej vieme zabezpečiť spoľahlivý a rýchly rozvoz mäsa a mäsových výrobkov priamo k Vám. Čerstvosť a kvalita sú pre nás prvoradé – preto si celý proces prepravy riadime sami, bez sprostredkovateľov.',
	'distribution.paragraph.mobileShop.detail':
		'Predstavujeme Vám, naše pojazdné predajne, ktoré sú plne vybavené na rozvoz a predaj čerstvého mäsa a mäsových výrobkov. Pravidelne nás môžete stretnúť v rámci obcí Košíce-okolie. Chceli by ste, aby sme s našou pojazdnou predajňou zavítali aj k Vám? Neváhajte nás ',

	// About Us Page
	'aboutUs.heading.story': 'Naš Príbeh',
	'aboutUs.heading.farm': 'Chov hovädzieho dobytka a ošípanej mangalice',
	'aboutUs.heading.production': 'Rozrábka hovädzieho a bravčového mäsa',
	'aboutUs.heading.distribution': 'Distribúcia mäsa a mäsových výrobkov',

	// Home Page
	'home.about.text_1': 'Naším zámerom je vyrábať výrobky v čo najvyššej kvalite a prispôsobovať sa potrebám našich zákazníkov.',
	'home.about.text_2': 'Kvalita mäsa je priamo spojená so zvieratami a kvalitou ich života. A preto je dôvod, prečo naše výrobky pochádzajú iba z fariem, ktoré dôkladne poznáme..',
	'home.about.text_3':
		'Sme malé mäsiarstvo s viac ako 30 ročnou históriou a na našich predajných pultoch nájdete vždy bohatý výber čerstvého mäsa, mäsových výrobkov a udenín. Pri nákupe si môžete byť istý, že nakupujete to nejkvalitnejšie mäso a výrobky z nich.',
	'home.about.erik': 'Efektivita - Racionalita - Iniciativa - Kvalita',
	'home.menu.products.title': 'Aktuálna Ponuka',
	'home.menu.products.body':
		'Hodnota našich výrobkov je priamo spätá z ich pôvodom. Mäso berieme výhradne od farmárov s hlbokou znalosťou kvality ich života, ktorá sa výrazne prejavuje na kvalite mäsa.',

	// Stores Page
	'stores.heading.store.name': 'Podniková predajňa',
	'stores.heading.store.ourStore': 'Naša predajňa',
	'stores.heading.store.address': 'Pri Krásnej 3, 040 12 Košice',

	'aboutUs.heading.year': 'Naša cesta sa začala v 1993.',
	'aboutUs.paragraph.formation':
		'Firma ERIK vznikla v roku 1993, ako združenie dvoch fyzických osôb a v roku 1998 sa rozšírila na právnu formu ERIK, s.r.o. so sídlom Pri Krásnej 3 v Košiciach. Firma sa venuje primárne spracovaniu, rozrábaniu bravčového, hovädzieho mäsa a výrobe vlastných mäsových výrobkov. ' +
		'Dlhoročne sa venovala sa chovom ošípaných z mangalíc a chovom hovädzieho dobytka „ ABERDEEN ANGUS“.',
	'aboutUs.paragraph.distribution':
		'Naše produkty doručujeme vlastnou dopravou priamo k zákazníkom – od škôl, nemocníc a reštaurácií až po domovy sociálnych služieb či malospotrebiteľov. Spoľahlivo zásobujeme celý východoslovenský kraj, vždy s dôrazom na čerstvosť a kvalitu.',
	'aboutUs.paragraph.farm_1':
		'Kvalita bola vždy našou prioritou. V minulosti sme vlastnili vlastné farmy, kde sme sa starali o chov vysokokvalitného hovädzieho a bravčového dobytka, ako bol Aberdeen Angus a mangalica. Zvieratá žili vo voľných výbehoch, v prostredí bez stresu, s dôrazom na prirodzený rast a výživu – to všetko sa odrážalo na výnimočnej chuti a kvalite mäsa.',
	'aboutUs.paragraph.farm_2':
		'Tieto skúsenosti formovali náš prístup k výrobe a ostávajú základom našej filozofie aj dnes. Hoci už farmy nevlastníme, spolupracujeme výhradne s overenými dodávateľmi, ktorí zdieľajú naše hodnoty a nároky na kvalitu. Práve vďaka tejto filozofii vieme zabezpečiť, že každý výrobok, ktorý opustí našu prevádzku, spĺňa najprísnejšie štandardy.',
	'aboutUs.paragraph.production':
		'Mäso spracovávame s dôrazom na kvalitu, čerstvosť a úctu k surovine. Hovädzie aj bravčové rezy sú precízne oddelené, správne vyzreté a pripravené tak, aby si zachovali šťavnatosť a chuť. Vďaka našim skúsenostiam vieme ponúknuť mäso vhodné na bežné varenie aj výnimočné príležitosti.',

	'enum.distribution.shop': 'Vyzdvihnutie na predajni',
	'enum.distribution.courier': 'Donáška',
	'enum.distribution.mobileShop': 'Mobilná predajňa',

	'enum.order.status.created': 'Čaká na spracovanie',

	'button.confirm': 'Potvrdiť',
	'button.toBasket': 'Do košíka',
	'button.goHome': 'Domov',
	'button.home.about': 'Viac o našom mäse',

	'text.invoice.other': 'Iná fakturačná adresa',
	'text.product.description': 'Opis',
	'text.product.composition': 'Zloženie',
	'text.product.storeAt': 'Skladovanie',
	'text.product.nutritionalValues': 'Výživové hodnoty',
	'text.product.allergens': 'Alergény',

	//header

	'header.dropdown.settings': 'Nastavenia',
	'header.dropdown.profile': 'Profil',
	'header.dropdown.orders': 'Moje Objednavky',
	'header.dropdown.account': 'Môj Účet',
	'header.dropdown.signIn': 'Prihlásenie',
	'header.dropdown.logOut': 'Odhlásenie',
	'header.dropdown.registration': 'Registrácia',

	// User
	'user.registration.main.title': 'Registrácia Užívateľa',
	'user.registration.title': 'Registrácia',
	'user.registration.terms.marketingNews':
		'Prostredníctvom e-mailu vám môžeme zasielať dôležité informácie týkajúce sa spustenia predaja, prípadné zmeny, novinky z diania v klube, atď. Súhlasím so zasielaním e-mailových noviniek.',

	'user.account.profile.changePassword.title': 'Zmena Hesla',
	'user.account.profile.changePassword.submit': '',

	'user.account.profile.changeInvoiceData.title': 'Fakturačné údaje',

	'user.account.profile.changePersonalData.title': 'Kontaktné údaje',
	'user.account.response.success': 'Údaje úspešne uložené',
	'user.account.response.error': 'Údaje sa nepodarilo úspešne uložiť',

	// Match List Page
	'eventList.empty': 'Neboli nájdené žiadne zápasy. Skúste to, prosím, neskôr znova.',

	// Orders

	// Orders Basket
	'orders.basket.title': 'Košík',
	'orders.basket.button.toCheckout': 'K platbe',
	'orders.button.toCheckout': 'K platbe',
	'orders.button.toPayment': 'Potvrdiť a zaplatiť',

	'orders.basket.summery.total': 'Celková cena',
	'orders.basket.summery.reserve': 'Rezerva na vážený tovar',
	'orders.basket.summery.distribution': 'Doprava',
	'orders.basket.summery.sum': 'Cena na úhradu',

	'order.summery.payment.title': 'Spôsob platby',
	'order.summery.distribution.title': 'Doprava: ',

	'order.success.title': 'Ďakujeme za vašu objednávku',
	'order.success.confirmation': 'Vašu objednávku sme úspešne prijali. Potvrdenie vám zároveň posielame na e-mailovu adresu.',

	// Orders Checkout
	'orders.checkout.invoice.title': 'Vaše údaje',
	'orders.checkout.addressData.title': 'Adresa Doručenia',
	'orders.checkout.invoiceData.title': 'Fakturačné údaje',
	'orders.checkout.distribution.title': 'Spôsob doručenia',
	'orders.checkout.payment.title': 'Spôsob platby',
	'orders.checkout.distribution.calendar.title': 'Termín doručenia',
	'orders.checkout.distribution.calendar.date': 'Vyberte dátum doručenia',
	'orders.checkout.distribution.calendar.time': 'Rozvoz sa zabezpečuje od 8:00 do 18:00',

	'orders.checkout.address.change': 'Upraviť adresu',
	'orders.checkout.invoice.change': 'Upraviť údaje',

	// Products

	'products.item.card.inBasket': 'Pridané do košíka',

	// Tooltip

	'tooltip.price.reserve': 'Pri váženom tovare sa pripočíta záloha za váženy tovar. Po dodaní tovaru bude rozdiel na cene vratený a strhne sa cena totožná s faktúrov',

	// Product Filter

	'filter.menu.title': 'Aktuálna Ponuka',
};

const t = (key: string, ...args: Array<string | number | undefined>): string => {
	const translation = translations[key];
	if (typeof translation === 'function') {
		return translation(...args.map((value) => (value ? value.toString() : '')));
	}
	return translation || '###' + key + '###';
};

export default t;
